import {toast} from "react-toastify";
import _ from "lodash";
import {Typography} from "@material-tailwind/react";

export const Toaster = {
  success: (status, data, message = "عملیات موفق") => {
    if (status === 200) {
      toast.success(
        <Typography>
          {message}
        </Typography>
        , {
          position: "top-right",
          closeOnClick: true
        });
    }
  },
  failure: (ex, message = "عملیات ناموفق") => {
    if (ex && ex.response && ex.response.data) {
      _.forEach(ex.response.data, function (value, key) {
        toast.error(`${key}: ${value} `, {
          position: "top-right",
          closeOnClick: true
        });
      });
    } else {
      toast.error(
        <Typography>
          {message}
        </Typography>
        , {
          position: "top-right",
          closeOnClick: true
        });
    }
  }
};
